import { Field, FormikProps, getIn } from "formik";
import * as React from "react";
import { IStepProps } from "src/Interfaces/FormProps";
import { IFormValues } from "src/Interfaces/FormValues";
import ButtonGroup from "../forms/partials/ButtonGroup";
import {countries} from 'src/data/countries';

import { withTranslation, WithTranslation } from 'react-i18next';
import { t } from "i18next";
interface IOfficeAddress {
    office_address: any[];
    currentIndex: number;
}
interface IProps extends WithTranslation {
    prop: any;
  }
  
  interface IState {
    state: any;
  }
class Step2 extends React.Component<
    FormikProps<IFormValues> & IStepProps,
    IOfficeAddress,{prop:IProps , state:IState}
> {
    constructor(props: IStepProps & FormikProps<IFormValues>) {
        super(props);
        this.state = {
            currentIndex: 0,
            office_address: [
                {
                    address:
                        "14/f, China Hong Kong Tower,\n 8 Henessy Road, Wanchai",
                    country: "Hong Kong",
                    disabled: true
                },
                {
                    address:
                        "Suite 2401-2, 24/F, 135 Bonham Strand Trade Centre, 135 Bonham Strand East, Sheungwan",
                    country: "Hong Kong",
                    disabled: true
                },
                {
                    address: "",
                    country: "",
                    disabled: false
                }
            ]
        };
    }
    public componentDidMount() {
        this.handleAddressChange(0);
        this.props.validateForm();
    }

    public handleAddressChange(index: number) {
        const { setFieldValue } = this.props;
        this.setState({
            currentIndex: index
        });
        setFieldValue(
            "company.address",
            this.state.office_address[index].address
        );
        setFieldValue(
            "company.country",
            this.state.office_address[index].country
        );
    }
    public render() {
        const { office_address, currentIndex } = this.state;
        const { errors, touched } = this.props;

        const buttonProps = {
            nextStep: () => {
                if (!getIn(errors, "company")) {
                    this.props.nextStep();
                }
                this.props.setAllFieldsTouched("company");
            },
            back: this.props.back
        };
        return (
            <div className="col-12 col-md-8 mx-auto">
                <h1 className="my-3">{t(`contactInfomration.companyDetails`)}</h1>

                <div className="row">
                    <div className="form-group col-12">
                        <label>{t(`contactInfomration.Company Name(First preference)`)} </label>
                        <Field
                            type="text"
                            className="form-control"
                            name="company.companyname_1"
                            placeholder="Centre O"
                        />
                        {getIn(errors, "company.companyname_1") &&
                            getIn(touched, "company.companyname_1") && (
                                <small className="text-danger small">
                                    {getIn(errors, "company.companyname_1")}
                                </small>
                            )}
                    </div>
                    <div className="form-group col-12">
                        <label>{t(`contactInfomration.Company Name(Second preference)`)}  </label>
                        <Field
                            type="text"
                            className="form-control"
                            name="company.companyname_2"
                            placeholder="Business Service"
                        />
                        {getIn(errors, "company.companyname_2") &&
                            getIn(touched, "company.companyname_2") && (
                                <small className="text-danger small">
                                    {getIn(errors, "company.companyname_2")}
                                </small>
                            )}
                    </div>

                    <div className="form-group col-12">
                        <p className="my-0">
                        {t(`contactInfomration.description`)}
                        </p>
                    </div>

                    <div className="form-group col-12">
                        <label>{t(`contactInfomration.Nature Of Business`)}</label>
                        <Field
                            type="text"
                            className="form-control"
                            name="company.nature_of_business"
                            placeholder="Manufacture"
                        />
                    </div>
                    <div className="form-group col-12">
                        <label>{t(`contactInfomration.Registered Office Address`)}</label>
                        <div className="row mx-0 align-items-center mb-3">
                            <button
                                className={`col-auto btn btn--inactive ${
                                    currentIndex === 0 ? "active" : ""
                                }`}
                                type="button"
                                onClick={this.handleAddressChange.bind(this, 0)}
                            >
                                {t(`contactInfomration.CENTRE-O-WHACHAI`)}
                            </button>
                            {/* <button
                                className={`col-auto btn btn--inactive ${
                                    currentIndex === 1 ? "active" : ""
                                }`}
                                type="button"
                                onClick={this.handleAddressChange.bind(this, 1)}
                            >
                                Centre O Sheungwan
                            </button> */}
                            <button
                                className={`col-auto btn btn--inactive ${
                                    currentIndex === 2 ? "active" : ""
                                }`}
                                style={{ width: "379px" }}
                                type="button"
                                onClick={this.handleAddressChange.bind(this, 2)}
                            >
                                {t(`contactInfomration.USE-ANOTHER-ADDRESS`)}
                            </button>
                        </div>
                        <Field
                            component="textarea"
                            className="form-control"
                            name="company.address"
                            disabled={office_address[currentIndex].disabled}
                        />
                        {getIn(errors, "company.address") &&
                            getIn(touched, "company.address") && (
                                <small className="text-danger small">
                                    {getIn(errors, "company.address")}
                                </small>
                            )}
                    </div>

                    <div className="form-group col-12">
                        <label>{t(`contactInfomration.Country`)}</label>
                        <Field
                            component="select" 
                            name="company.country"
                            className="form-control"
                            disabled={office_address[currentIndex].disabled}
                        >
                            <option value="" label="Select a country">Select a country</option>
                            {
                                countries.map((country:any) => (
                                    <option key={country.name} value={country.name} label={country.name}>{country.name}</option>
                                ))
                            }
                        </Field>
              
                        {getIn(errors, "company.country") &&
                            getIn(touched, "company.country") && (
                                <small className="text-danger small">
                                    {getIn(errors, "company.country")}
                                </small>
                            )}
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation('info')(Step2)
